<template>
  <div class="productdetail">
    <headd :mobile_title="mobile_title"></headd>
    <div class="kv hidden-lg hidden-md">
      <img :src="detail.kvpath" />
    </div>
    <div class="container">
      <div class="detail_info">
        <div class="kv hidden-sm hidden-xs">
          <img :src="detail.kvpath" />
        </div>
        <div class="dcontent">
          <div class="info_title">{{ detail.title }}</div>
          <div class="info_price"><span>￥</span>{{ detail.show_price }}</div>
          <div class="info_desc">
            {{ detail.shortdesc }}
          </div>
          <div class="info_tip">
            <div
              class="tip_item"
              v-for="item in detail.serviceadg_array"
              :key="item"
            >
              <img class="tip_icon" src="../../static/product/icon_1.png" />

              {{ item }}
            </div>
          </div>

          <div class="buy_item" v-if="detail.option_array != ''">
            <div class="buy_title" v-if="detail.option_title != ''">
              {{ detail.option_title }}
            </div>
            <div class="buy_zz">
              <div
                class="zz"
                :class="{ active: isChange == index }"
                v-for="(item, index) in detail.option_array"
                :key="index"
                :data-price="item.optionprice"
                :data-index="index"
                :data-option="item.option"
                @click="selecttype"
              >
                {{ item.option }}
              </div>
            </div>
          </div>

          <div class="buy_item" v-if="detail.otheroption_array != ''">
            <div class="buy_title" v-if="detail.otheroption_title != ''">
              {{ detail.otheroption_title }}
            </div>
            <div class="buy_zz">
              <div
                class="zz"
                :class="{ active: isChange2 == index }"
                v-for="(item, index) in detail.otheroption_array"
                :key="index"
                :data-index="index"
                :data-option="item"
                @click="selecttype2"
              >
                {{ item }}
              </div>
            </div>
          </div>
        </div>
        <div class="buy_btn">
          <div class="bbtn btnzx" @click="kefu">客服咨询</div>
          <div class="bbtn btngm" @click="payorder">立即购买</div>
        </div>
      </div>
      <div class="detail_box">
        <div class="box_title">产品详情</div>
        <div class="box_content" v-html="detail.page_content"></div>
      </div>
    </div>
    <indexbanner :adbannerlist="banner_1" :config="config_1"></indexbanner>
    <foot></foot>

    <el-dialog title="" :visible.sync="dialogFormVisible" width="7rem">
      <div class="common_poup">
				<div class="poup_banner">
					<img src="../../static/poup/banner.png" />
				</div>
				<div class="box">
					<div class="box_title">
						<img class="title_icon" src="../../static/poup/icon.png" />填写信息
					</div>
					<div class="dbox_cell">
						<div class="dbox_name">姓名</div>
						<div class="dbox_input"><input type="text" v-model="leads.name"  placeholder="请输入" class="input"></input></div>
					</div>
					<div class="dbox_cell">
						<div class="dbox_name">手机号码</div>
						<div class="dbox_input"><input type="text"  maxlength="11" v-model="leads.tel"  placeholder="请输入" class="input"></input></div>
					</div>
					<div class="dbox_cell">
						<div class="dbox_name">需求描述</div>
						<div class="dbox_input"><textarea class="textarea" v-model="leads.otherdesc"  placeholder="请输入"></textarea></div>
					</div>

					<div class="btn_save" @click="btn_save">提交</div>
				</div>
			</div>
    </el-dialog>
  </div>
</template>

<script>
import indexbanner from "../components/indexbanner.vue";
import headd from "@/components/head";
import foot from "@/components/foot";
import { getappads, getproductdetail, getkefuchannel,getleads } from "./api/api"; //引入api里面定义的方法
export default {
  data() {
    return {
      id: 0,
      detail: {},
      index: 0,
      index2: 0,
      isChange: "-1",
      isChange2: "-1",
      price: 0,
      banners: [
        {
          id: 1,
          img: "../../static/product/ad.png"
        }
      ],
      texts: "测试数据",
      option: "",
      otheroption: "",
      page_content: "",
      kfid: 0,
      service2: "",
      banner_1: [],
      config_1: false,
      mobile_title: "",
      dialogFormVisible: false,
       leads: {
					name:'',
					tel:'',
					otherdesc:''
				}
    };
  },
   metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    indexbanner,
    headd,
    foot
  },
  async mounted() {
    this.getappads();
    this.getProductDetail();
  },
  methods: {
      async btn_save() {

				var _self = this
                var data = _self.leads
                var phone_reg = /^1[3456789]\d{9}$/
				if (data.name == '') {

					
                    this.$toast('请输入名字')
					return false
				}
				if (data.tel == '') {

				
                    this.$toast('请输入电话')
					return false
				}else{
					if (!phone_reg.test(data.tel)) { 
						
                        this.$toast('手机号码格式错误')
						return false
					}
				}

				var parm = {
					tel: data.tel,
					name: data.name,
					otherdesc: data.otherdesc,
					service: this.service2,
				}

				const res = await getleads(parm)
				if (res.status == 1) {
                
         this.$toast({
          message: "提交成功",
          type: "success"
        });
        _self.leads.name = ''
                        _self.leads.tel = ''
                        _self.leads.otherdesc = ''
                        _self.dialogFormVisible= false
					
				}
			},
    async getappads() {
      var _self = this;

      const res = await getappads("combo_ads");
      //console.log(res);

      _self.banner_1 = res.data.data.appads;
    },

    async getProductDetail() {
      //   var _self = this;
      var parm = this.$route.query;
      var data = {
        did: parm.id
      };
      const res = await getproductdetail(data);
      this.detail = res.data.data;
      this.id = parm.id;
      this.mobile_title = res.data.data.title;
      this.price = res.data.data.current_price;
      this.array = res.data.data.option_array;
    },
    selecttype(e) {
      //console.log(e)
      var _slef = this;
      var index = e.currentTarget.dataset.index;
      var option = e.currentTarget.dataset.option;
      var price = e.currentTarget.dataset.price;
      if (index != this.isChange) {
        this.isChange = index;
        _slef.option = option;
        var price_new = price == 0 ? "面议" : price;
        _slef.detail.show_price = price == 0 ? "面议" : price;
      } else {
        this.isChange = -1; //不注释则可以点击取消，注释之后点击就不再取消
        _slef.option = "";
        _slef.detail.show_price = _slef.price;
      }
      //console.log(_slef.detail.show_price)
    },
    selecttype2(e) {
      var _slef = this;
      var index = e.currentTarget.dataset.index;
      var otheroption = e.currentTarget.dataset.option;
      //console.log(index);
      if (index != this.isChange2) {
        this.isChange2 = index;
        _slef.otheroption = otheroption;
      } else {
        this.isChange2 = -1; //不注释则可以点击取消，注释之后点击就不再取消
        _slef.otheroption = "";
      }
    },
    async payorder() {
      var _self = this;
      if (_self.detail.option_array != "") {
        if (_self.option == "") {
          this.$toast("请选择" + _self.detail.option_title);
          return false;
        }
      }
      if (_self.detail.otheroption_array != "") {
        if (_self.otheroption == "") {
          this.$toast("请选择" + _self.detail.otheroption_title);
          return false;
        }
      }

      var data = {
        uid: localStorage.getItem("userId"),
        comboid: _self.id,
        option: _self.option,
        otheroption: _self.otheroption
      };
      console.log(data);
      if (_self.detail.show_price == "面议") {
        this.service2 = _self.detail.title;
        this.dialogFormVisible= true
      } else {
        this.$router.push({
          name: "orderpay",
          query: {
            uid: data.uid,
            comboid: data.comboid,
            option: data.option,
            otheroption: data.otheroption
          }
        });
      }
    },
    async kefu() {
      var _self = this;
      var data = { uid: localStorage.getItem("userId") };
      const res = await getkefuchannel(data);
      //console.log(res)
      if (res.data.status == 1) {
        var uid = localStorage.getItem("userId");
        var recipient_id = res.data.data.kfid;
        this.$router.push({
          path: "chat",
          query: {
            uid: uid,
            recipient_id: recipient_id
          }
        });
      }
    }
  },
  beforeCreate: function() {
    document.getElementsByTagName("body")[0].className = "body_back";
  },
  beforeDestroy: function() {
    document.body.removeAttribute("class", "body_back");
  }
};
</script>

<style lang="less">
.body_back {
  @media (max-width: 991px) {
    background: #f2f2f2;
  }
}

.productdetail {
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  @media (max-width: 991px) {
    .container {
      width: 6.86rem;
      padding: 0;
    }
  }

  margin: 0 auto 0.32rem auto;

  .kv {
    margin-bottom: 0.2rem;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .detail_info {
    width: 8rem;
    margin: 0.32rem auto;
    @media (max-width: 991px) {
      width: 6.86rem;
      margin: 0.16rem auto;
      border: 0;
      .container {
        padding: 0;
      }
    }
    padding: 0.2rem;
    background: #ffffff;
    border: 0.01rem solid #ccc;
    border-radius: 0.2rem;
    flex-direction: column;

    overflow: hidden;
    text-align: left;

    .dcontent {
      flex-direction: column;

      .info_price {
        font-size: 0.4rem;
        font-weight: bolder;
        color: #ff545a;
        line-height: 0.67rem;
        @media (max-width: 991px) {
          font-size: 0.6rem;
        }

        span {
          font-size: 0.3rem;
          @media (max-width: 991px) {
            font-size: 0.36rem;
          }
        }
      }

      .info_title {
        font-size: 0.24rem;
        font-weight: bolder;
        color: #1b1c33;
        line-height: 0.37rem;
        margin-bottom: 0.1rem;
        @media (max-width: 991px) {
          font-size: 0.36rem;
          line-height: 0.5rem;
        }
      }

      .info_desc {
        font-size: 0.14rem;
        color: #8d8e99;
        line-height: 0.17rem;
        margin-bottom: 0.3rem;
        @media (max-width: 991px) {
          font-size: 0.26rem;
          line-height: 0.3rem;
        }
      }

      .info_tip {
        flex-wrap: wrap;
        margin-bottom: 0.2rem;
        display: flex;

        .tip_item {
          font-size: 0.16rem;
          color: #1395ff;
          line-height: 0.25rem;
          margin-right: 0.3rem;
          align-items: center;
          margin-bottom: 0.1rem;
          display: flex;

          .tip_icon {
            width: 0.18rem;
            height: 0.18rem;
            margin-right: 0.05rem;

            img {
              width: 100%;
            }
          }
          @media (max-width: 991px) {
            font-size: 0.26rem;
            line-height: 0.3rem;
          }
        }
      }

      // }

      // .buy {
      // 	padding: 30rpx 20rpx;
      // 	width: 646rpx;
      // 	background: #FFFFFF;
      // 	border-radius: 20rpx;
      // 	flex-direction: column;
      // 	margin-bottom: 20rpx;

      .buy_item {
        margin-bottom: 0.2rem;
        display: flex;

        .buy_title {
          font-size: 0.16rem;
          color: #5e5e66;
          line-height: 0.25rem;
          margin-right: 0.2rem;
          width: 1rem;
          @media (max-width: 991px) {
            font-size: 0.26rem;
            line-height: 0.42rem;
            width: 1.3rem;
          }
        }

        .buy_pick {
          width: 1.79rem;
          height: 0.5rem;
          background: url(../../static/product/icon_2.png) no-repeat;
          background-size: 1.79rem 0.5rem;
        }

        .buy_zz {
          flex-wrap: wrap;
          width: 100%;
          display: flex;

          .zz {
            padding: 0.1rem 0.16rem;
            background: rgba(19, 149, 255, 0.09);
            border-radius: 0.1rem;
            margin-right: 0.15rem;
            margin-bottom: 0.2rem;
            font-size: 0.16rem;
            color: #1395ff;
            cursor: pointer;
            @media (max-width: 991px) {
              font-size: 0.26rem;
            }
          }

          .zz.active {
            background: #1395ff;
            color: #fff;
          }
        }

        .buy_computer {
          width: 179rpx;
          height: 50rpx;
          background: url(../../static/product/icon_6.png) no-repeat;
          background-size: 179rpx 50rpx;

          .minus {
            width: 48rpx;
            height: 50rpx;
            background: url(../../static/product/icon_7.png) no-repeat;
            background-size: 48rpx 50rpx;
          }

          .amount {
            padding: 5rpx;
            width: 73rpx;
            height: 40rpx;
            line-height: 40rpx;
            text-align: center;

            input {
              width: 100%;
              height: 100%;
              font-size: 30rpx;
            }
          }

          .add {
            width: 48rpx;
            height: 50rpx;
            background: url(../../static/product/icon_8.png) no-repeat;
            background-size: 48rpx 50rpx;
          }
        }
      }
    }

    .buy_btn {
      justify-content: space-around;
      display: flex;
      flex-wrap: wrap;

      .bbtn {
        width: 2.7rem;
        height: 0.7rem;
        font-size: 0.24rem;
        color: #ffffff;
        line-height: 0.7rem;
        justify-content: center;
        align-items: center;
        border-radius: 0.4rem;
        text-align: center;
        cursor: pointer;
        @media (max-width: 991px) {
          font-size: 0.3rem;
        }
      }

      .bbtn.btnzx {
        background-color: #1395ff;
      }

      .bbtn.btngm {
        background-color: #f4556c;
      }
    }
  }

  .detail_box {
    width: 8rem;
    @media (max-width: 991px) {
      width: 100%;
      border: 0;
    }
    background: #ffffff;
    border: 0.01rem solid #ccc;
    padding: 0.2rem;
    background: #ffffff;
    border-radius: 0.2rem;
    margin: 0 auto 0.2rem auto;
    flex-direction: column;
    text-align: left;

    .box_title {
      padding-left: 0.18rem;
      font-size: 0.24rem;
      color: #1b1c33;
      line-height: 0.33rem;
      margin-bottom: 0.2rem;
      position: relative;
      @media (max-width: 991px) {
        font-size: 0.36rem;
        line-height: 0.5rem;
      }

      &:before {
        content: "";
        position: absolute;
        top: 0.03rem;
        left: 0;
        width: 0.08rem;
        height: 0.28rem;
        background: url(../../static/product/icon_3.png) no-repeat;
        background-size: 0.08rem 0.28rem;
        @media (max-width: 991px) {
          top: 0.1rem;
        }
      }
    }

    .box_content {
      flex-direction: column;
      font-size: 0.16rem;
      line-height: 0.25rem;
      color: #1b1c33;
      @media (max-width: 991px) {
        font-size: 0.36rem;
        line-height: 0.5rem;

        img {
          width: 100% !important;
          height: auto !important;
          margin-bottom: 0.2rem;
        }
      }

      .gif_img {
        border-radius: 0.12rem;
        margin-bottom: 0.2rem;

        img {
          width: 100%;
          border-radius: 0.12rem;
        }
      }
      img {
        width: 100% !important;
        height: auto !important;
        margin-bottom: 0.2rem;
        @media (max-width: 991px) {
          width: 100% !important;
          height: auto !important;
          margin-bottom: 0.2rem;
        }
      }
      p {
      }
    }
  }
}
.common_poup {
		width: 100%;
		height:auto;
		background-color: #ffffff;
		border-radius: 0rem;
		flex-direction: column;

		.poup_banner {
			width: 100%;
			height: 2rem;
            overflow: hidden;

			img {
				width: 100%;
				
			}
		}

		.box {
			margin: 0.2rem auto;
			width: 96%;
			height: auto;
			flex-direction: column;

			.box_title {
				font-size: 0.16rem;
				line-height: 0.25rem;
				margin-bottom: 0.2rem;
                align-items: center;
                display: flex;
                align-items: center;
                
                 @media (max-width: 991px) {
                        font-size: 0.32rem;
                        line-height: 0.42rem;
                        height: auto;
                    }

				.title_icon {
					width: 0.18rem;
					height: 0.18rem;
					margin-right: 0.1rem;
                     @media (max-width: 991px) {
                        width: 0.28rem;
                        height: 0.28rem;
                        
                    }
				}
			}

			.dbox_cell {
				align-items: center;
				justify-content: space-between;
                margin-bottom: 0.2rem;
                display: flex;

				.dbox_name {
					width: 1.25rem;
					height: 0.25rem;
					font-size: 0.16rem;
					color: #5E5E66;
					line-height: 0.25rem;
					text-align: justify;
					display: inline-block;
                    @media (max-width: 991px) {
                        font-size: 0.28rem;
                        line-height: 0.33rem;
                        height: auto;
                    }
					// text-align-last: justify;
				}

				.dbox_input {
					width: 4.63rem;

					.input {
						width: 3.83rem;
						line-height: 0.24rem;
						padding: 0.1rem 0.12rem;
						background: rgba(196, 196, 204, 0.1);
                        border-radius: 0rem;
                        border:0.01rem solid #ccc;
						font-size: 0.16rem;
						color: #333;
                         @media (max-width: 991px) {
                        font-size: 0.28rem;
                        line-height: 0.33rem;
                        height: auto;
                        padding: 0.17rem 0.12rem;
                    }
					}

					.textarea {
						width: 3.83rem;
						height: 1rem;
						line-height: 0.25rem;
						padding: 0.1rem 0.12rem;
						background: rgba(196, 196, 204, 0.1);
						border-radius: 0rem;
                        border:0.01rem solid #ccc;
						font-size: 0.16rem;
						color: #333;
                        resize: none;
                         @media (max-width: 991px) {
                        font-size: 0.28rem;
                        line-height: 0.33rem;
                        height: auto;
                        padding: 0.17rem 0.12rem;
                    }
					}

					.select {
						width: 100%;
						height: 0.66rem;
						border: 0;
						background-color: rgba(196, 196, 204, 0.1);
                         @media (max-width: 991px) {
                        font-size: 0.28rem;
                        line-height: 0.33rem;
                        height: auto;
                    }
					}
				}
			}

			.btn_save {
				margin: 0.5rem auto 0 auto;
				width: 2.7rem;
				height: 0.7rem;
				line-height: 0.7rem;
                border-radius: 0.35rem;
				background: #1395ff;
				font-size: 0.24rem;
				color: #FFFFFF;
				align-items: center;
				justify-content: center;
                 @media (max-width: 991px) {
                        font-size: 0.28rem;
                       
                    }
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/productdetail.vue